import { ComponentRef, Directive, HostListener, Input, ViewContainerRef, Renderer2, Output, EventEmitter } from '@angular/core';
import { GasDynamicComponentsService } from '@cikrf/gas-utils/services';

import { GasContextGroup, GasContextMenu, GasMenySize } from '../gas-menu.interface';
import { GasContextMenuComponent } from './gas-context-menu.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

/** @see https://www.figma.com/file/yqBeq1MiGfpdN62SvmA8tg/RTLABS_GAS_DS_1?node-id=5651%3A59 */
/** @description Директива для динамического создания контекстного меню */
/** @example
 * <div gasContextMenu [contextMenu]="menu" [size]="size" (onChangeLink)="changeLink($event)">
 *  Показать контекстное меню
 * </div>
 */
@UntilDestroy()
@Directive({
  selector: '[gasContextMenu]',
})
export class GasContextMenuDirective {
  @Output('onChangeLink')
  public onChangeLink$ = new EventEmitter<GasContextMenu>();
  /** пункты меню */
  @Input()
  public gasContextMenu: GasContextGroup[] = [];

  /** Размер элемента меню */
  @Input()
  public size: GasMenySize | string = 'large';

  public isOpened = false;
  public contextMenuRef: ComponentRef<GasContextMenuComponent>;

  constructor(
    private gasDynamicComponentsService: GasDynamicComponentsService,
    private viewContainerRef: ViewContainerRef,
    private renderer2: Renderer2,
  ) {
    this.renderer2.addClass(this.viewContainerRef.element.nativeElement, 'g-position-r');
  }

  /** подписка на клик по триггеру */
  @HostListener('click', ['$event'])
  public clickHandler(event: MouseEvent): void {
    event.stopPropagation();

    if (this.isOpened) {
      this.removeComponent();
    } else {
      this.createComponent();
    }
  }

  /** создание компонента */
  public createComponent(): void {
    const offsetTop = this.viewContainerRef.element.nativeElement.clientHeight + 'px';
    /** если на странице несколько менюшек, удаляем все кроме последней открытой */
    document.querySelectorAll('gas-context-menu').forEach(menu => menu.remove());

    this.contextMenuRef = this.gasDynamicComponentsService.createChildComponent(GasContextMenuComponent, this.viewContainerRef);

    /** Прокидываем инпуты в компонент */
    Object
      .keys(this)
      .forEach(key => {
        /** прокидываем в компонент только те параметры, которые нужны для корректной работы */
        if (this.contextMenuRef.instance[key]) {
          this.contextMenuRef.instance[key] = this[key];
        }
      });

    this.renderer2.setStyle(this.contextMenuRef.location.nativeElement, 'top', offsetTop);
    this.renderer2.setStyle(this.contextMenuRef.location.nativeElement, 'left', '0px');

    this.contextMenuRef.instance.onMenuClicked$
      .pipe(
        untilDestroyed(this),
      ).subscribe((menuItem: GasContextMenu) => this.onChangeLink$.emit(menuItem));

    this.contextMenuRef.instance.closeContextMenuSubject$
      .pipe(
        untilDestroyed(this),
      ).subscribe(() => this.removeComponent());

    this.isOpened = true;
  }

  /** Удаление компонента */
  public removeComponent(): void {
    this.gasDynamicComponentsService.deleteComponent(this.contextMenuRef);
    this.contextMenuRef = null;
    this.isOpened = false;
  }

}
